import $ from "jquery";

export default () => $("html, body").animate({scrollTop: "0px"}, 300);
